module.exports = __webpack_public_path__ + "img/op.e1321c62.svg";